import React from "react";

import { TableCell, TableRow } from "@mui/material";
import clsx from "clsx";

import mainStyles from "../../../styles";

export const OrgSettingsTableHeader = () => {
  const classes = mainStyles();
  return (
    <TableRow data-testid="org-settings-table-header">
      <TableCell className={clsx(classes.tableCell)} align="center">
        Key
      </TableCell>
      <TableCell className={clsx(classes.tableCell)} align="center">
        Value
      </TableCell>
      <TableCell className={clsx(classes.tableCell)} align="center">
        Entity
      </TableCell>
    </TableRow>
  );
};
